import React, { useState, useEffect, useRef, useContext } from 'react'
import ReactDOM from 'react-dom'
import cn from 'classnames'
import styled, { createGlobalStyle, withTheme } from 'styled-components'
import { uniq } from 'lodash'
import ActionsContext from '../ActionsContext'
import { hasLevel3 } from '../../utils'
import Icon from '../Iconfont'
import NavigationPopup from './NavigationPopup'

const Navigation = styled.li`
  &.active {
    color: ${({ theme }) => theme.primaryColor} !important;
  }
  font-size: ${({ theme: { size } }) => (size === 'large' ? '14px' : '12px')};
  .tnt-icon {
    font-size: ${({ theme: { size } }) => (size === 'large' ? '22px' : '18px')};
    margin-right: 4px;
  }
  span {
    position: relative;
    font-size: ${({ theme: { size } }) => (size === 'large' ? '14px' : '12px')};
    top: ${({ theme: { size } }) => (size === 'large' ? '-3px' : '-2px')};
    font-family: auto;
    .tnt-themeS1 & {
      /* color: rgba(255,255,255,.85); */
    }
  }
  .isInIframe & {
    display: none;
  }
`

const createPopupContainer = () => {
  const div = document.createElement('div')

  div.setAttribute('class', 'tnt-navigation-popup')

  return div
}

const GlobalStyle = createGlobalStyle`
    .tnt-navigation-popup {
        position: absolute;
        left: 0;
        top: ${(props) => (props.theme.size === 'large' ? '60px' : '50px')};
        width: 100%;
        height: ${(props) => (props.hasLevel3 ? '560px' : '530px')};
        background: #FFF;
        box-shadow: 0 10px 10px -8px rgba(0,0,0,.1) inset,
                    0 10px 10px -8px rgba(0,0,0,.1);
        transition: all .15s ease-in-out;
        overflow: hidden;
        padding: 20px 16px;
        box-sizing: border-box;
        &.hide {
            height: 0;
            padding: 0;
        }
    }
`

export default withTheme((props) => {
  const actions = useContext(ActionsContext)
  const { getText } = actions
  const { headerRef, menus } = props
  const [visible, setVisible] = useState(false)
  const popupRef = useRef()

  useEffect(() => {
    popupRef.current = createPopupContainer()
    headerRef?.current?.appendChild(popupRef.current)

    return () => {
      headerRef?.current?.removeChild(popupRef.current)
    }
  }, [])

  useEffect(() => {
    const classNames = popupRef.current.getAttribute('class').split(' ')

    if (visible) {
      ReactDOM.render(
        <NavigationPopup
          actions={actions}
          theme={props.theme}
          menus={menus}
          containerRef={headerRef}
          popupRef={popupRef}
          close={() => setVisible(false)}
        />,
        popupRef.current
      )
      popupRef.current.setAttribute('class', classNames.filter((item) => item !== 'hide').join(' '))
    } else {
      popupRef.current.setAttribute('class', uniq([...classNames, 'hide']).join(' '))
    }
  }, [visible])

  return (
    <Navigation
      onClick={(evt) => {
        evt.stopPropagation()
        evt.nativeEvent?.stopImmediatePropagation()
        evt.nativeEvent?.stopPropagation()
        setVisible(!visible)
      }}
      className={cn({ active: visible })}
    >
      <Icon type="unordered-list" />
      <span>{getText('globalNavigation')}</span>
      <GlobalStyle hasLevel3={hasLevel3(menus)} />
    </Navigation>
  )
})
